/* House style: middle dots, not dashes, in button labels, and "remade", not "re-poured", in stock lines.
   global.js rebuilds these strings on swatch change; this swaps them back.
   The product form's own submit button is included: global.js rewrites it on every swatch click too. */
(function () {
  function fix() {
    document.querySelectorAll('[data-buy-label], .sticky-add .btn, #ProductForm button[type=submit], [data-product-form] button[type=submit]').forEach(function (el) {
      if (el.children.length === 0 && el.textContent.indexOf(' — ') > -1) el.textContent = el.textContent.replace(' — ', ' · ');
    });
    document.querySelectorAll('[data-stock-line]').forEach(function (el) {
      if (el.innerHTML.indexOf('re-poured') > -1) el.innerHTML = el.innerHTML.replace('re-poured', 'remade');
    });
  }
  document.addEventListener('click', function (e) { if (e.target.closest('[data-swatch]')) setTimeout(fix, 0); });
  document.addEventListener('DOMContentLoaded', fix);
})();

/* Colorway photos. When a shopper picks a swatch, the gallery jumps to that colorway's photo.
   Each variant's photo is the image attached to the variant in Shopify admin (Products > variant > image).
   A variant with no image leaves the gallery where it is. The URL also updates to ?variant=, so a shared
   link opens on the same colorway. */
(function () {
  var wrap = document.querySelector('[data-swatches]');
  var gallery = document.querySelector('[data-gallery]');
  if (!wrap || !gallery) return;
  var path = location.pathname.replace(/\/$/, '');
  if (path.indexOf('/products/') === -1) return;
  fetch(path + '.js').then(function (r) { return r.json(); }).then(function (p) {
    var mediaIndex = {};
    (p.media || []).forEach(function (m, i) { mediaIndex[m.id] = i; });
    var byVariant = {};
    (p.variants || []).forEach(function (v) {
      if (v.featured_media && mediaIndex[v.featured_media.id] !== undefined) byVariant[v.id] = mediaIndex[v.featured_media.id];
    });
    function show(variantId) {
      var i = byVariant[variantId];
      if (i === undefined) return;
      var thumbs = document.querySelectorAll('[data-thumb]');
      if (thumbs[i]) { thumbs[i].click(); return; }
      var imgs = gallery.querySelectorAll('img');
      imgs.forEach(function (im, j) { im.classList.toggle('on', j === i); });
      gallery.querySelectorAll('.pg-dots span').forEach(function (d, j) { d.classList.toggle('on', j === i); });
      var c = gallery.querySelector('.pg-counter');
      if (c) c.textContent = (i + 1) + ' / ' + imgs.length;
    }
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-swatch]');
      if (!b) return;
      var id = b.getAttribute('data-variant');
      show(Number(id));
      if (window.history && history.replaceState) {
        var u = new URL(location.href);
        u.searchParams.set('variant', id);
        history.replaceState(null, '', u);
      }
    });
    var start = new URL(location.href).searchParams.get('variant');
    if (start) show(Number(start));
  }).catch(function () {});
})();
